import React, { type FC } from "react";
import { Button } from "@heroui/react";
import { FormattedMessage } from "react-intl";

import { AuthLayout } from "./AuthLayout";

/**
 * Shown to a signed-in user who is not attached to any company.
 *
 * Companies are provisioned by staff after the sales call - the customer never
 * creates one - so instead of a "create company" affordance the user gets an
 * explanation and a way to reach support. Rendered by
 * `AuthWrapper.AuthenticatedRoute`, which is also where the email-verification
 * gate (`NotConfirmed`) lives, so the two post-sign-in gates stay side by side.
 */
const PENDING_TITLE = <FormattedMessage id="app.companies.pending.title" tagName="h1" />;

const SUPPORT_VALUES = { email: <a href="mailto:support@binale.de">support@binale.de</a> };

// The company list is fetched once per auth state change, so a reload is what makes a
// freshly assigned company appear.
const reloadPage = () => window.location.reload();

export const CompanySetupPending: FC = () => {
    return (
        <AuthLayout title={PENDING_TITLE}>
            <div className="flex flex-col gap-4 p-2">
                <FormattedMessage id="app.companies.pending.description" tagName="p" />
                <p>
                    <FormattedMessage id="app.companies.pending.contact" values={SUPPORT_VALUES} />
                </p>
                <Button fullWidth size="lg" onPress={reloadPage}>
                    <FormattedMessage id="app.error_page.button.reload_page" />
                </Button>
            </div>
        </AuthLayout>
    );
};
